



















import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class AlertSubscriptionButton extends Vue {

    @Prop({default: false}) isSubscriptionActive: boolean;
    @Prop({default: false}) hasSubscriptionError: boolean;

    toggleSubscription() {
        this.$emit('toggleSubscription');
    }
}
